import { render, staticRenderFns } from "./DialogEscuelaSeleccionar.vue?vue&type=template&id=1b37dca6&"
import script from "./DialogEscuelaSeleccionar.vue?vue&type=script&lang=js&"
export * from "./DialogEscuelaSeleccionar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports